import { Link, Typography } from '@mui/material';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

let UpperGrid = styled(Grid)(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'center'
}));

const SourceTextSection = ({ labels, sourceUrl, sourceLinkLabel }) => {
    return (
        <UpperGrid item>
            <Typography
                sx={{ fontSize: '10px', fontStyle: 'italic', marginTop: '5px', fontWeight: 600 }}
            >
                {labels.source}:{' '}
                <Link
                    sx={{ fontWeight: 400, textDecoration: 'none', color: '#7BA4D2' }}
                    href={sourceUrl}
                    target={'_blank'}
                >
                    {sourceLinkLabel}
                </Link>
            </Typography>
            <Typography sx={{ fontSize: '10px', fontStyle: 'italic', marginRight: '5px' }}>
                {labels.infoMessage}
            </Typography>
        </UpperGrid>
    );
};

export default SourceTextSection;
